import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

interface RemovePartyMembershipVariables {
  partyId: string;
  targetUserId: string;
}

export function useRemovePartyMembership(facilityId: string) {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, RemovePartyMembershipVariables>({
    mutationFn: ({ partyId, targetUserId }) =>
      queueApi.removePartyMembership(partyId, targetUserId),
    onSettled: (_data, _error, { partyId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.partyMemberships(facilityId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.myParty(facilityId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.party.detail(partyId),
        refetchType: "active",
      });
    },
  });
}
